<template>
  <div id="signin">
    <div id="form">
      <LoginForm
        v-if="showAuthChoices"
        :choices="authMethods"
        @choose="redirectAuth"
      />
    </div>
  </div>
</template>

<script>
import AuthenticationService from '@/services/api/authentication/authentication-service';
import LoginForm from '@/components/authentication/LoginForm';
import { mapGetters } from 'vuex';

export default {
  name: 'SignIn',
  components: {
    LoginForm,
  },
  computed: {
    ...mapGetters(['authMethods']),
    billingId() {
      return this.$route.params.billingid;
    },
    showAuthChoices() {
      return this.authMethods.length > 1;
    },
  },
  methods: {
    redirectAuth(auth) {
      this.$router.push({
        name: 'request-auth',
        params: { syncguid: auth.syncguid },
        query: {
          redirect: this.$route.query.redirect || undefined,
        },
      });
    },
  },
  mounted() {
    AuthenticationService.getAuthentications({
      billingId: this.billingId,
    })
      .then(res => {
        this.$store.commit('setAuthMethods', res);
        if (this.authMethods.length === 0) {
          this.$router.push({ name: 'no-authentication' });
        }
        if (this.authMethods.length === 1) {
          this.redirectAuth(this.authMethods[0]);
        }
      }).catch(() => this.$router.push({ name: 'no-authentication' }));
  },
};
</script>

<style lang="less" scoped>
#signin {
  width: 100vw;
  height: 100vh;
  background-color: #221d24;
  color: #fff;

  #form {
    display: block;
    margin: auto;
    max-width: 700px;
    max-height: 1000px;
  }
}
</style>
